import React, { Component, Fragment } from "react";
import styled from "@emotion/styled";
import Sticky from "Components/Sticky/index";
import styles from "./EXIMCargoTracking.module.scss";
import {
  PageWrapperT2,
  PageWrapperT4,
} from "Components/Common/Wrapper/PageWrapper";
import {
  HeaderSection,
  TabButtonSection,
  ShipmentFileUploadAndDownloadSection,
  InprogressAndCompletedFilterBox,
  ShipmentDetailsTable,
  InprogressAndCompletedTable,
  ModalCardT2,
  RoutesDetailsTable,
  EventStatusTable
} from "Components/EXIMCargoTracking/Index";
import { Spacer } from "Components/Common/Spacer/index";
import {
  GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
  GET_EXIM_CARGO_TEMPLATE,
  GET_EXIM_CONTAINER_BL_TRACKING_DETAILS,
  GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
  TOAST_ERROR,
  UPLOAD_EXIM_CARGO_TEMPLATE,
  POST_ON_DEMAND_TRACKING
} from "Constants/actionConstants";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ActionBlurLoader from "Components/ActionLoader/LoaderWithBlur";
import ModalT1 from "Components/Common/Modal/ModalT1";
import ModalCardT1 from "Components/RateComparison/CalculationForFreight/ModalCardT1";
import ModalCardT3 from "Components/EXIMCargoTracking/ModalCardT3";
import AdditionalFilesDetailsCard from "Components/EXIMCargoTracking/AdditionalFilesDetailsCard";
import InlandTrackingTable from "Components/EXIMCargoTracking/InlandTrackingTable";

class EXIMCargoTracking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedShipment: "seaShipment",
      selectedTab: 1, // for identification purposes only
      eximCargoTemplateFile: null,
      eximCargoTemplateFileName: "",
      isModalPopupOpen: false,
      selectItemForMoreInformationPopup: {},
      selectItemForAdditionalFilesDetails: {},
      selectItemForEventDetails: {},
      modalType: 1, // for identification purposes only
      filter: {
        source: null,
        destination: null,
        status: null,
        from: null,
        to: null,
      },
      offset: 0,
      limit: 10
    };
  }

  componentDidMount() {
    // this.handleGetEximCargoTemplate();
    this.handleGetEximContainerBlTrackingDetails();
    this.handleGetEximCargoSourceDestinationPortListAndStatusList();
    this.handleGetEximContainerBlTrackingDetailsTemplate();
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedTab, filter } = this.state;

    if (prevState.selectedTab !== selectedTab || prevState.filter !== filter) {
      // this.setState({
      //   filter: {
      //     ...filter,
      //     status: null,
      //   },
      // });
      this.handleGetEximContainerBlTrackingDetails();
    }
  }

  handleGetEximCargoSourceDestinationPortListAndStatusList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
    });
  };
  handleGetEximCargoTemplate = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_EXIM_CARGO_TEMPLATE,
      onSuccess: (data) => {
        this.handleDownloadEximCargoTemplateFile(data);
      }
    });
  };
  handleGetEximContainerBlTrackingDetailsTemplate = (
    isContainerNumberWise = false,
    containerNumber
  ) => {
    const { dispatch } = this.props;
    const onSuccessContainerNumberWise = (url) => {
      this.handleDownloadEximContainerBlTrackingDetailsTemplateFile(url);
    };
    dispatch({
      type: GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
      payload: {
        isContainerNumberWise,
        onSuccessContainerNumberWise,
        queryParams: {
          containerNumber,
        },
      },
    });
  };

  handleOnClickDownloadContainerBlTrackingFile = (containerNumber) => {
    this.handleGetEximContainerBlTrackingDetailsTemplate(true, containerNumber);
  };

  handleGetEximContainerBlTrackingDetails = () => {
    const { dispatch } = this.props;
    const { selectedTab, filter, limit, offset } = this.state;
    const updateFilter = {
      status: !!filter.status && selectedTab === 2 ? filter.status.value : null,
      source: !!filter.source ? filter.source.value : null,
      destination: !!filter.destination ? filter.destination.value : null,
      from: !!filter.from ? filter.from.value : null,
      to: !!filter.to ? filter.to.value : null,
      containerNumber: filter.containerNumber || null,
      blNumber: !!filter.blNumber ? filter.blNumber.value : null,
      categoryName: !!filter.categoryName ? filter.categoryName.value : null,
      limit,
      offset
    };
    dispatch({
      type: GET_EXIM_CONTAINER_BL_TRACKING_DETAILS,
      queryParams: {
        type: selectedTab === 4 ? 3 : selectedTab,
        ...updateFilter,
      },
    });
  };
  handleOnClickBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  handleOnClickSelectedTab = (selectedTab) => {
    this.setState({ selectedTab });
  };
  handleDownloadEximCargoTemplateFile = (eximCargoTemplateFileUrl) => {
    // const { eximCargoTemplateFileUrl } = this.props;
    const link = document.createElement("a");
    link.href = eximCargoTemplateFileUrl;
    link.setAttribute("download", true);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  handleDownloadEximContainerBlTrackingDetailsTemplateFile = (url) => {
    const { eximContainerBlTrackingDetailsTemplateFileUrl } = this.props;
    const link = document.createElement("a");
    link.href = !!url ? url : eximContainerBlTrackingDetailsTemplateFileUrl;
    link.setAttribute("download", true);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  handleOnChangeForEximCargoTemplateFile = (event) => {
    const eximCargoTemplateFile = event.target.files[0];
    const eximCargoTemplateFileName = eximCargoTemplateFile.name;
    this.setState({ eximCargoTemplateFile, eximCargoTemplateFileName });
  };
  handleOnClickUploadForEximCargoTemplateFile = () => {
    const { eximCargoTemplateFile } = this.state;
    const { dispatch } = this.props;
    const formData = new FormData();
    if (eximCargoTemplateFile !== null) {
      const onSuccess = () => {
        this.handleGetEximContainerBlTrackingDetails();
      };
      formData.append("file", eximCargoTemplateFile);
      dispatch({
        type: UPLOAD_EXIM_CARGO_TEMPLATE,
        payload: formData,
        onSuccess,
      });
    } else {
      dispatch({
        type: TOAST_ERROR,
        message: "Please Upload File",
      });
    }
  };

  handleModalPopupOpen = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: true,
      };
      return updatepreviousState;
    });
  };

  handleModalPopupClose = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: false,
      };
      return updatepreviousState;
    });
  };

  handleOnclickForMoreInformationPopup = (data) => {
    this.setState(
      { selectItemForMoreInformationPopup: data, modalType: 1 },
      () => {
        this.handleModalPopupOpen();
      }
    );
  };
  handleOnClickAdditionalFiles = (data) => {
    this.setState(
      { selectItemForAdditionalFilesDetails: data, modalType: 2 },
      () => {
        this.handleModalPopupOpen();
      }
    );
  };
  handleFilterBoxOnChange = (data, name) => {
    const { filter } = this.state;
    const updateFilter = {
      ...filter,
      [name]: data,
    };
    this.setState({ filter: updateFilter, offset: 0 });
  };

  handleOnclickEventStatusInformationPopup = (data) => {
    this.setState(
      { selectItemForEventDetails: data, modalType: 3 },
      () => {
        this.handleModalPopupOpen();
      }
    );
  }

  goToPage = (pageNumber) => {
    const { limit } = this.state; 
    const newOffset = (pageNumber - 1) * limit;
    this.setState({
        offset: newOffset,
    }, () => {
      this.handleGetEximContainerBlTrackingDetails();
    });
   
}

handleOnClickOnDemandTracking = (containerNo) => {
  const { dispatch } = this.props;
  dispatch({
    type: POST_ON_DEMAND_TRACKING,
    payload: {
      container_number: containerNo
    },
    onSuccess: () => {
      this.handleGetEximContainerBlTrackingDetails();
    }
  });
}

  render() {
    const {
      selectedShipment,
      selectedTab,
      eximCargoTemplateFileName,
      isModalPopupOpen,
      selectItemForMoreInformationPopup,
      modalType,
      selectItemForAdditionalFilesDetails,
      filter,
      selectItemForEventDetails
    } = this.state;
    console.log(
      "selectItemForAdditionalFilesDetails:",
      selectItemForAdditionalFilesDetails
    );
    const {
      loaderT1,
      uploadShipmentDetailsList,
      sourcePortList,
      destinationPortList,
      statusList,
      inprogressShipmentDetailsList,
      completedShipmentDetailsList,
      blNumbers,
      trackingCount,
      categoryList
    } = this.props;
    return (
      <Fragment>
        {loaderT1 && <ActionBlurLoader fixed={true} />}
        <div className="navBarWrapper">
          <Sticky></Sticky>
        </div>

        <ModalT1
          isOpenState={isModalPopupOpen}
          handleOnClickForClose={this.handleModalPopupClose}
        >
          {modalType === 1 && (
            <ModalCardT2
              selectItemForMoreInformationPopup={
                selectItemForMoreInformationPopup
              }
            >
              <RoutesDetailsTable
                selectItemForMoreInformationPopup={
                  selectItemForMoreInformationPopup
                }
              />
            </ModalCardT2>
          )}

          {modalType === 2 && (
            <ModalCardT3 title={"Additional Files"}>
              <AdditionalFilesDetailsCard
                data={selectItemForAdditionalFilesDetails}
              />
            </ModalCardT3>
          )}
          
          {modalType === 3 && (
            <ModalCardT2
            selectItemForMoreInformationPopup={
                selectItemForEventDetails
              }
              modalType={modalType}
            >
              <EventStatusTable
                data={
                  selectItemForEventDetails
                }
              />
            </ModalCardT2>
          )

          }
        </ModalT1>

        <PageWrapperT4>
          <HeaderSection handleOnClickBack={this.handleOnClickBack} />
          <Spacer spacing={"10px"} />
          <TabButtonSection
            handleOnClickSelectedTab={this.handleOnClickSelectedTab}
            selectedTab={selectedTab}
          />
          <Spacer spacing={"10px"} />
          {selectedTab === 1 && (
            <ShipmentFileUploadAndDownloadSection
              handleDownloadEximCargoTemplateFile={
                this.handleGetEximCargoTemplate
              }
              handleOnChangeForEximCargoTemplateFile={
                this.handleOnChangeForEximCargoTemplateFile
              }
              eximCargoTemplateFileName={eximCargoTemplateFileName}
              handleOnClickUploadForEximCargoTemplateFile={
                this.handleOnClickUploadForEximCargoTemplateFile
              }
            />
          )}
          {(selectedTab === 2 || selectedTab === 3 || selectedTab === 4) && (
            <InprogressAndCompletedFilterBox
              selectedTab={selectedTab}
              sourcePortList={sourcePortList}
              destinationPortList={destinationPortList}
              statusList={statusList}
              handleDownloadEximContainerBlTrackingDetailsTemplateFile={
                this.handleDownloadEximContainerBlTrackingDetailsTemplateFile
              }
              handleFilterBoxOnChange={this.handleFilterBoxOnChange}
              filter={filter}
              blNumbers={blNumbers}
              trackingCount={trackingCount}
              goToPage={this.goToPage}
              offset={this.state.offset}
              limit={this.state.limit}
              categoryList={categoryList}
            />
          )}
          <Spacer spacing={"10px"} />
          {selectedTab === 1 && (
            <ShipmentDetailsTable
              uploadShipmentDetailsList={uploadShipmentDetailsList}
            />
          )}
          {(selectedTab === 2 || selectedTab === 3) && (
            <InprogressAndCompletedTable
              selectedTab={selectedTab}
              inprogressShipmentDetailsList={inprogressShipmentDetailsList}
              completedShipmentDetailsList={completedShipmentDetailsList}
              handleOnclickForMoreInformationPopup={
                this.handleOnclickForMoreInformationPopup
              }
              handleOnClickDownloadContainerBlTrackingFile={
                this.handleOnClickDownloadContainerBlTrackingFile
              }
              handleOnClickAdditionalFiles={this.handleOnClickAdditionalFiles}
              handleOnclickEventStatusInformationPopup={this.handleOnclickEventStatusInformationPopup}
              handleOnClickOnDemandTracking={this.handleOnClickOnDemandTracking}
            />
          )}
          {/* {(selectedTab === 4) &&
            (<InlandTrackingTable
              selectedTab={selectedTab}
              completedShipmentDetailsList={completedShipmentDetailsList}
              handleOnclickEventStatusInformationPopup={this.handleOnclickEventStatusInformationPopup}
            />)
          } */}
        </PageWrapperT4>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("state:", state);
  return {
    loaderT1: !!state.common.loaderT1,
    eximCargoTemplateFileUrl: state.EXIMCargoTracking.eximCargoTemplateFileUrl,
    eximContainerBlTrackingDetailsTemplateFileUrl:
      state.EXIMCargoTracking.eximContainerBlTrackingDetailsTemplateFileUrl,
    uploadShipmentDetailsList:
      state.EXIMCargoTracking.uploadShipmentDetailsList,
    inprogressShipmentDetailsList:
      state.EXIMCargoTracking.inprogressShipmentDetailsList,
    completedShipmentDetailsList:
      state.EXIMCargoTracking.completedShipmentDetailsList,
    sourcePortList: state.EXIMCargoTracking.sourcePortList,
    destinationPortList: state.EXIMCargoTracking.destinationPortList,
    statusList: state.EXIMCargoTracking.statusList,
    blNumbers: state.EXIMCargoTracking.blNumbers,
    trackingCount: state.EXIMCargoTracking.trackingCount,
    categoryList: state.EXIMCargoTracking.categoryList
  };
};

export default connect(mapStateToProps)(withRouter(EXIMCargoTracking));
